function BulletSlider(el) {
    new Flickity(el, {
        prevNextButtons: false,
        adaptiveHeight: true,
        pageDots: true
    });
}

(function() {
    const bulletSliderEls = document.querySelectorAll('.jsBulletSlider');
    [...bulletSliderEls].map(el => new BulletSlider(el));
})();
